const schema = {
  title: {
    type: 'text',
    label: 'Question',
    placeholder: 'Enter !uestion',
    required: true,
    info: true,
    character_count: 250,
    disabled: true
  },
  description: {
    type: 'ckeditor',
    label: 'Answer',
    placeholder: 'Enter Answer',
    required: true,
    info: false,
  }
};

const pcnCategories = ['EMIS'];

const faqs = [
  {
    id: 'faq1',
    expanded: false,
    title: "Frequently asked question 1",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: true
  },
  {
    id: 'faq2',
    expanded: false,
    title: "Frequently asked question 2",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: true
  },
  {
    id: 'faq3',
    expanded: false,
    title: "Frequently asked question 3",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: false
  },
  {
    id: 'faq4',
    expanded: false,
    title: "Frequently asked question 4",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: true
  },
  {
    id: 'faq5',
    expanded: false,
    title: "Frequently asked question 5",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: true
  },
  {
    id: 'faq6',
    expanded: false,
    title: "Frequently asked question 6",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem.",
    active: true
  }
]

export { schema, faqs, pcnCategories };